export const apiPath = '/v1/companies';
const actionType = 'COMPANY_V2';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
